import { dayMonthDateString, timeStringFromDate } from '@nextforce/api'
import React, { useState } from 'react'
import Datetime from 'react-datetime'
import 'react-datetime/css/react-datetime.css'
import { Platform, View } from 'react-native'
import { Collapsible } from './collapsible'
import './style.css'

export interface Props {
  title: string
  value: Date | undefined
  onChange(date: Date): void
  mode: 'date' | 'time'
  maxDate?: Date
  minDate?: Date
  disabled?: boolean
  minuteInterval?: number
}

export function DateTimeChooser({
  title,
  value: date,
  mode,
  maxDate,
  minDate,
  minuteInterval,
  disabled,
  onChange,
}: Props) {
  const [expanded, setExpanded] = useState(false)

  return (
    <View style={{ borderRadius: 20 }}>
      <Collapsible
        title={title}
        value={
          mode === 'date' ? dayMonthDateString(date) : timeStringFromDate(date)
        }
        expanded={expanded}
        disabled={disabled}
        onPress={() => setExpanded(!expanded)}
        icon={Platform.OS === 'android' ? null : undefined}
      >
        <Datetime
          input={false}
          value={date ?? new Date()}
          dateFormat={mode === 'date' ? true : false}
          timeFormat={mode === 'time' ? true : false}
          closeOnClickOutside={true}
          closeOnSelect={true}
          className={'react-calendar'}
          isValidDate={(
            currentDate: moment.Moment,
            selectedDate: moment.Moment
          ) => {
            if (maxDate && currentDate.isAfter(maxDate)) {
              return false
            }
            if (minDate && currentDate.isBefore(minDate)) {
              return false
            }
            return true
          }}
          timeConstraints={
            minuteInterval
              ? {
                  minutes: {
                    step: minuteInterval,
                  },
                }
              : {}
          }
          onChange={(selectedDate: string | moment.Moment) => {
            if (selectedDate) {
              return onChange(selectedDate as unknown as Date)
            }
          }}
        />
      </Collapsible>
    </View>
  )
}
